import toast from "react-hot-toast";
import { Navigate } from "react-router-dom";

const LogoutCallback = (message) => {
      localStorage.removeItem("email");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("token");
      localStorage.removeItem("employeeId");
      localStorage.removeItem("mobileApiUrl");
      localStorage.removeItem("outseta.auth--poisum.outseta.com.settings");
      localStorage.removeItem("outseta.emailList--poisum.outseta.com.settings");
      localStorage.removeItem("outseta.leadCapture--poisum.outseta.com.settings")
      localStorage.removeItem("outseta.nocode--poisum.outseta.com.settings");
      localStorage.removeItem("outseta.support--poisum.outseta.com.settings");
      localStorage.removeItem("isFirstTime");
      localStorage.removeItem("showOnboarding");

      sessionStorage.clear();

    toast.error(message, {
      position: "top-center",
      autoClose: 6000,
    });


    Navigate("/verifyEmail");
  };

export default LogoutCallback;
